<template>
    <div
            :aria-label="title"
            :class="'content-card-' + type"
            class="content-card"
            role="button"
            tabindex="0"
            v-on:click.prevent="$emit('onClick')"
            v-on:keyup.space="$emit('onClick')">
        <div class="media-container">
            <img :alt="mediaAlt" :src="mediaUrl" v-if="media">
        </div>
        <div class="title">
            {{ title }}
        </div>
        <slot></slot>
    </div>
</template>

<script>
    import {MediaUtil} from '@/utils/MediaUtil'

    export default {
        name: 'content-card',
        props: {
            title: {
                type: String,
                required: true
            },
            media: {
                type: String,
                required: false
            },
            type: {
                type: String,
                required: false,
                default: 'default'
            }
        },
        computed: {
            mediaUrl() {
                return MediaUtil.getMediaUrl(this.media)
            },
            mediaAlt() {
                return MediaUtil.getMediaAlt(this.media)
            }
        }
    }
</script>
<style lang="less" scoped>
    @import "~@less/mixins/mixins.less";

    .content-card {
        border-radius: 5px;
        background: white;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
        transition: all 0.2s ease-in-out;
        min-height: 230px;
        z-index: 100;
        min-width: 300px;
        cursor: pointer;
        position: relative;
        margin: 10px;
        overflow: hidden;

        &:hover, &:focus {
            box-shadow: 1px 6px 10px rgba(0, 0, 0, 0.5);
        }

        .media-container {
            height: 200px;
            width: 100%;
            text-align: center;
            padding: 25px;

            img {
                max-width: 100%;
                max-height: 100%;
            }
        }

        .title {
            text-align: center;
        }

        &.content-card-index {
            max-width: 300px;
            background: #DBE7E8;

            .title {
                background: white;
                margin-left: -15px;
                margin-right: -15px;
                position: relative;
                top: 0px;
                font-weight: bold;
                padding-top: 10px;
                padding-bottom: 10px;
            }
        }
    }

    .media-min-md({
        .content-card {
            &:hover {
                box-shadow: 1px 6px 10px rgba(0, 0, 0, 0.5);
                transform: scale(1.03);
                z-index: 500;
            }
        }
    });

    .media-lg({
        .content-card {
            min-height: 239px;
        }
    });

    .media-xl({
        .content-card {
            min-height: 248px;
        }
    });

    .media-xxl({
        .content-card {
            min-height: 256px;
        }
    });
</style>
